import { Outlet } from "react-router-dom";
import ReferralLinkBar from "@/components/affiliate/ReferralLinkBar";
import AssetsSubNav from "@/components/affiliate/AssetsSubNav";
import { C } from "@/lib/brand";

// Assets is now a content-hub layout. It renders the sticky referral-link
// bar + sub-section navigation at the top, and delegates the actual
// content to nested route children (AssetsIndex, AssetsCompliance,
// AssetsPlaybooks, etc).
//
// Sub-routes are defined in /app/frontend/src/App.js under the
// /affiliates/dashboard/assets parent.
export default function AffiliateAssets() {
  return (
    <div data-testid="affiliate-assets" style={{ background: C.cream, minHeight: "calc(100vh - 64px)" }}>
      <ReferralLinkBar />
      <AssetsSubNav />
      <main>
        <Outlet />
      </main>
    </div>
  );
}
